import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=1e3a090a&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/js/ckeditor/ckeditor.css?vue&type=style&index=0&id=1e3a090a&prod&scoped=true&lang=css&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=1e3a090a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3a090a",
  null
  
)

export default component.exports